import comp from '../components/barrel';
import svg from '../js/svg';
import U from '../js/utils';
import listReturnState from '../js/listReturnState';

export default {
  async prepare() {
    const vars = {};
    vars.filters = {};
    const listRestore = this.vars && this.vars.listRestore;
    if (listRestore && listRestore.filters) {
      this.vars.selected_page = listRestore.selected_page || 1;
      this.recipe.methods.push(
        await O.mPOST('users/get-user-list', {
          filters: {...listRestore.filters},
          page: listRestore.selected_page || 1,
          limit: 10,
        })
      );
    } else {
      this.recipe.methods.push(await O.mPOST('users/get-user-list', vars));
    }
    this.recipe.methods.push(await O.mPOST('communal/divisions', vars));
    this.recipe.methods.push(await O.mPOST('communal/div-branches', vars));
    this.recipe.methods.push(await O.mPOST('communal/organisations', vars));
    this.recipe.methods.push(await O.mPOST('communal/org-branches', vars));
  },

  async render() {
    const rec = this.recipe.methods;

    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }

    await this.loadPage(data);
  },

  async loadPage(data) {
    const listReturn = this.vars && this.vars.listRestore;
    // Pass endpoints to table head
    await this.buildTableHead(data);

    if (listReturn) {
      this.applyListReturnToDom(listReturn);
      delete this.vars.listRestore;
    }
    // Fetch user list data then pass to table body to be rendered as rows
    const listData = data[`users/get-user-list`];
    const usersListData = listData.data;
    await this.buildTableBody(usersListData);

    // Set state to current page then call function responsible for building pagination
    const paginationState = listData.pagination;
    thsPage.vars.selected_page = paginationState.current_page;
    this.buildPaginationButtons(paginationState);
  },

  async buildTableHead(data) {
    const companyDDdata = await data[`communal/divisions`].data.divisions;
    const companyBranchesDDdata = await data[`communal/div-branches`].data;
    const orgDDdata = await data[`communal/organisations`].data;
    const orgBranchesDDdata = await data[`communal/org-branches`].data;

    const tableHead = U.id('tableHead');
    tableHead.innerHTML = '';
    const headRow = tableHead.insertRow();

    // ACTION (icons column - first)
    headRow.insertCell(0);

    // FIRST NAME
    const fName = headRow.insertCell(1);
    fName.innerHTML = 'First Name';

    // LAST NAME
    const sName = headRow.insertCell(2);
    sName.innerHTML = 'Last Name';

    // ADVISOR CODE
    const advisorCode = headRow.insertCell(3);
    advisorCode.innerHTML = 'Advisor Code';

    // STATUS
    const statusDDdata = [
      {short_text: 'Active', status_value: true},
      {short_text: 'Inactive', status_value: false},
    ];

    const status = headRow.insertCell(4);
    let statusDD = await comp.selectThead('statusDD', statusDDdata, 'status_value', 'short_text', 'thsPage.getUserList()', 'Status');
    status.appendChild(statusDD);
    headRow.appendChild(status);

    // DIVISION
    const company = headRow.insertCell(5);
    let companyDD = await comp.selectThead('companyDD', companyDDdata, 'division_uuid', 'short_text', 'thsPage.getUserList()', 'Company');
    company.appendChild(companyDD);
    headRow.appendChild(company);

    // DIVISION BRANCH
    const companyBranch = headRow.insertCell(6);
    let companyBranchDD = await comp.selectThead('companyBranchDD', companyBranchesDDdata, 'division_branch_uuid', 'short_text', 'thsPage.getUserList()', 'Company Branch');
    companyBranch.appendChild(companyBranchDD);
    headRow.appendChild(companyBranch);

    // ORGANISATION
    const organisation = headRow.insertCell(7);
    let organisationDD = await comp.selectThead('organisationDD', orgDDdata, 'org_uuid', 'short_text', 'thsPage.getUserList()', 'Organisation');
    organisation.appendChild(organisationDD);
    headRow.appendChild(organisation);

    // ORGANISATION BRANCH
    const organisationBranch = headRow.insertCell(8);
    let organisationBranchDD = await comp.selectThead('organisationBranchDD', orgBranchesDDdata, 'org_branch_uuid', 'short_text', 'thsPage.getUserList()', 'Organisation Branch');
    organisationBranch.appendChild(organisationBranchDD);
    headRow.appendChild(organisationBranch);

    // ROLE
    const role = headRow.insertCell(9);
    role.innerHTML = 'Role';

  },

  applyListReturnToDom(lr) {
    if (!lr || !lr.filters) return;
    const f = lr.filters;
    if (U.id('genSearch')) U.id('genSearch').value = f.search_filters != null ? f.search_filters : '';
    if (U.id('statusDD')) U.id('statusDD').value = f.status != null ? f.status : '';
    if (U.id('companyDD')) U.id('companyDD').value = f.company != null ? f.company : '';
    if (U.id('companyBranchDD')) U.id('companyBranchDD').value = f.companyBranch != null ? f.companyBranch : '';
    if (U.id('organisationDD')) U.id('organisationDD').value = f.organisation != null ? f.organisation : '';
    if (U.id('organisationBranchDD')) U.id('organisationBranchDD').value = f.organisationBranch != null ? f.organisationBranch : '';
  },

  captureListReturnState() {
    return {
      filters: {
        search_filters: U.id('genSearch') ? U.id('genSearch').value.trim() : '',
        company: U.id('companyDD') ? U.id('companyDD').value : '',
        companyBranch: U.id('companyBranchDD') ? U.id('companyBranchDD').value : '',
        organisation: U.id('organisationDD') ? U.id('organisationDD').value : '',
        organisationBranch: U.id('organisationBranchDD') ? U.id('organisationBranchDD').value : '',
        status: U.id('statusDD') ? U.id('statusDD').value : '',
      },
      selected_page: thsPage.vars.selected_page
        ? parseInt(String(thsPage.vars.selected_page), 10) || 1
        : 1,
    };
  },

  async buildTableBody(listData) {
    const userListBody = U.id('tableBody');
    userListBody.innerHTML = '';

    // Use list data to build out table rows
    if (listData.length) {
      for (const row of listData) {
        const userRow = userListBody.insertRow();

        const editUser = userRow.insertCell(0);
        const linkSVG = svg.linkNewPage();
        linkSVG.style.cursor = 'pointer';
        linkSVG.setAttribute('role', 'button');
        linkSVG.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          listReturnState.save('ViewUser', {
            listPage: 'ManageUsers',
            state: this.captureListReturnState(),
          });
          O.PREP('ViewUser', `target_user_uuid=${row.user_uuid}`);
        });
        editUser.appendChild(linkSVG);

        const fName = userRow.insertCell(1);
        fName.innerHTML = row.f_name;

        const sName = userRow.insertCell(2);
        sName.innerHTML = row.s_name;

        const advisorCode = userRow.insertCell(3);
        advisorCode.innerHTML = row.broker_number != null && row.broker_number !== '' ? row.broker_number : 'N/A';

        const status = userRow.insertCell(4);
        const tag = await comp.statusTag(row.active_yn ? 'Active' : 'Inactive');
        status.appendChild(tag);

        const company = userRow.insertCell(5);
        company.innerHTML = row.division_text || 'N/A';

        const companyBranch = userRow.insertCell(6);
        companyBranch.innerHTML = row.division_branch_text || 'N/A';

        const organisation = userRow.insertCell(7);
        organisation.innerHTML = row.org_text || 'N/A';

        const organisationBranch = userRow.insertCell(8);
        organisationBranch.innerHTML = row.org_branch_text || 'N/A';

        const role = userRow.insertCell(9);
        role.innerHTML = row.role_text;
      }
    } else {
      const userRow = userListBody.insertRow();
      const empty = userRow.insertCell(0);
      empty.innerHTML = 'No users available.';
      empty.colSpan = 10;
    }
  },

  async buildPaginationButtons(paginationState) {
    // Render pagination button elements inside a pagination wrapper div
    await comp.paginationButtons({totalPages: paginationState.total_pages, wrapperID: 'usersPaginationWrapper'});
    // Once buttons are rendered then attach click event to each one
    const pageButtons = document.querySelectorAll('.pageButton');
    pageButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Set the pagination payload to match newly selected page
        thsPage.vars.selected_page = Number(e.target.getAttribute('value'));
        this.getUserList();
      });
    });
  },

  /** Call from the search input so a new query always starts at page 1. */
  async getUserListFromSearch() {
    thsPage.vars.selected_page = 1;
    return this.getUserList();
  },

  async getUserList() {
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      const filters = {};
      // Reference values of select inputs and assign as a key to the filters object
      filters.search_filters = U.id('genSearch').value.trim();
      filters.company = U.id('companyDD').value;
      filters.companyBranch = U.id('companyBranchDD').value;
      filters.organisation = U.id('organisationDD').value;
      filters.organisationBranch = U.id('organisationBranchDD').value;
      filters.status = U.id('statusDD').value;

      const vars = {};
      vars.filters = filters;
      vars.limit = 10;
      vars.page = parseInt(thsPage.vars.selected_page);

      // Send both user-uuid and filters object to endpoint to get list of users that match filters
      O.PREP([await O.mPOST('users/get-user-list', vars)])
        .then(async (res) => {
          const listData = res['users/get-user-list'];
          const usersListData = listData.data;
          const paginationState = listData.pagination;

          // Render new table body and pagination buttons
          await this.buildTableBody(usersListData);
          this.buildPaginationButtons(paginationState);
        })
        .catch(() => {});
    }, 500);
  },

  async clearSearch() {
    const searchInps = document.querySelectorAll('.searchInputs');
    searchInps.forEach((inp) => {
      inp.value = '';
    });

    this.getUserList();
  },
};
